import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';

// Hasta ahora una URL inexistente renderizaba una pantalla en blanco: no habia
// ninguna ruta que la recogiera. Esta pagina atrapa cualquier direccion que no
// exista, incluidas las de productos retirados que sigan indexadas en buscadores.
const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 sm:px-6 py-20">
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gray-100 border border-gray-200 mb-6">
          <Compass size={28} className="text-[#141414]" />
        </div>
        <p className="text-sm font-bold tracking-widest text-gray-400 mb-3">404</p>
        <h1 className="text-3xl md:text-4xl font-bold text-[#141414] mb-4">
          {t('not_found.title')}
        </h1>
        <p className="text-gray-600 leading-relaxed mb-8">
          {t('not_found.description')}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-xl bg-[#141414] text-white font-semibold hover:bg-gray-900 transition"
          >
            {t('not_found.home')}
          </Link>
          <Link
            to="/apps"
            className="px-6 py-3 rounded-xl bg-white text-[#141414] font-semibold border border-gray-200 hover:bg-gray-50 transition"
          >
            {t('not_found.apps')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
